import { Type } from "@sinclair/typebox";

//#region src/shared/bricks/props/boolean.ts
function boolean(title, defaultValue, options = {}) {
	return Type.Boolean({
		title,
		default: defaultValue ?? false,
		...options
	});
}

//#endregion
export { boolean };
//# sourceMappingURL=boolean.js.map